// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import constants from "@store/constants";
import { useInvoicePaymentContext } from "@store/Framework/Components/InvoicePaymentContext/InvoicePaymentContext";
import React, { FC } from "react";

export interface InvoicePaymentPageContainerProps extends WidgetProps {}

export interface InvoicePaymentPageContainerStyles {}

export const invoicePaymentPageContainerStyles: InvoicePaymentPageContainerStyles = {};

const styles = invoicePaymentPageContainerStyles;

const InvoicePaymentPageContainer: FC<InvoicePaymentPageContainerProps> = ({ id }) => {
    const { errorMessage, isLoading, isSubmitting } = useInvoicePaymentContext();

    if (errorMessage) {
        return null;
    }

    return <OrderLayout id={id} loading={isLoading || isSubmitting} loadComplete={!isLoading} />;
};

const widgetModule: WidgetModule = {
    component: InvoicePaymentPageContainer,
    definition: {
        group: constants.widgetGroup.invoicePayment,
        displayName: "Page Container",
        allowedContexts: [constants.pageType.invoicePayment],
    },
};

export default widgetModule;
